module.exports = __webpack_public_path__ + "img/FQC.b3d9ec7a.jpg";